import { Routes, Route } from 'react-router-dom';

import { List, AddEdit } from './';

export { MealPlansLayout };

function MealPlansLayout() {
    return (
        <div className="p-4">
            <div className="container">
                <Routes>
                    <Route index element={<List />} />
                    <Route path="edit/:selectedDate" element={<AddEdit />} />
                </Routes>
            </div>
        </div>
    );
}